import { computed, ref } from '@vue/composition-api'
import { groupBy, isEmpty, cloneDeep } from 'lodash-es'

import store from '@/store'
import { convertISODateTime } from '@/@core/utils/filter'
import { apiBooking } from '@/api'

// import { env } from '@/libs/env'

const CREATE_BOOKING_STORE_MODULE_NAME = 'app-create-booking'

const VJ_CHINA_REQUIRED_PASSPORT_IATA_CODES = new Set([
  'DOY', 'URC', 'JUH', 'WEH', 'CGQ', 'PVG', 'KOW', 'LUM', 'DDG', 'CGD',
  'HLH', 'TCZ', 'SHP', 'HTN', 'BSD', 'HDG', 'ENH', 'HYN', 'MXZ', 'LHK',
  'THQ', 'NGQ', 'KRL', 'DLC', 'DQA', 'XIN', 'SXJ', 'TCG', 'XIC', 'JDZ',
  'JGN', 'CHG', 'LLF', 'WEF', 'CNI', 'AAT', 'SHE', 'AKA', 'CIH', 'HNY',
  'LDS', 'YIW', 'YIH', 'SYM', 'LIA', 'UYN', 'BPX', 'AVA', 'XIL', 'HEK',
  'DIG', 'WXN', 'LYG', 'KCA', 'SWA', 'DAX', 'HUZ', 'MIG', 'IQN', 'LZH',
  'BAV', 'SZV', 'HMI', 'GOQ', 'IQM', 'AOG', 'GYU', 'HFE', 'INC', 'YNT',
  'DNH', 'JIC', 'JIQ', 'MDG', 'AQG', 'GYS', 'JJN', 'HIA', 'ZHA', 'BFU',
  'TGO', 'RUG', 'JIL', 'XEN', 'AEB', 'TYN', 'JHG', 'AKU', 'CIF', 'FUG',
  'YIN', 'ZAT', 'ZUH', 'LXA', 'SHS', 'YNJ', 'AYN', 'BHY', 'XUZ', 'WHU',
  'NAO', 'ZYI', 'TNH', 'NGB', 'OHE', 'ACX', 'JZH', 'FUO', 'JIU', 'JMU',
  'LCX', 'YNZ', 'HLD', 'LZY', 'BPL', 'LNJ', 'WUS', 'JUZ', 'JNG', 'HZG',
  'TXN', 'LZO', 'WUZ', 'YBP', 'XNN', 'NAY', 'XFN', 'TEN', 'HET', 'HSN',
  'LYI', 'JNZ', 'DAT', 'KWL', 'YUS', 'HJJ', 'ENY', 'KWE', 'ZHY', 'KRY',
  'HAK', 'JGS', 'NDG', 'NNY', 'FOC', 'CSX', 'KHN', 'SYX', 'LHW', 'YCU',
  'KHG', 'WNZ', 'CGO', 'DYG', 'CKG', 'TSN', 'SHA', 'LJG', 'PKX', 'HZA',
  'NKG', 'WHA', 'CTU', 'WUX', 'TAO', 'CAN', 'XMN', 'PEK', 'LYA', 'HRB',
  'DSN', 'DLU', 'XIY', 'TNA', 'SJW', 'NNG', 'TFU', 'HGH', 'CZX', 'SIA',
  'NTG', 'WUH', 'SZX', 'KMG',
])
// TPE => country TW
// "MFK","PIF","MZG","HCN","GNI","WOT","TTT","HUN","TSA","LZN","CYI","KNH","KYD","TNN","TPE","TXG","RMQ","KHH",

const SOURCE_CAN_BOOK_WITH_ANCILLARY = ['VN1A', 'VJ', 'VU', 'AK', 'TH', '1A', 'QH', 'TR', 'JQ']
const SOURCE_CAN_BOOK_WITH_SEAT = ['VN1A', 'VJ', 'VU', 'AK', 'QH', 'TR', 'JQ']

const sourcesRequireVerifyPrice = ['VN1A', '1A', '1B', 'TR', 'JQ']

const isChangeBundle = ref(false) // for bundle JQ
function toggleChangeBundle() { // for bundle JQ
  isChangeBundle.value = !isChangeBundle.value
}

// const { isDevelopment } = env

// eslint-disable-next-line arrow-body-style
const sourcesCanBuyAncillary = computed(() => { // HÀNH LÝ, DV KHÁC
  // if disable env
  return SOURCE_CAN_BOOK_WITH_ANCILLARY
})

// eslint-disable-next-line arrow-body-style
const sourcesCanBuySeat = computed(() => { // CHỖ NGỒI
  // if disable env
  return SOURCE_CAN_BOOK_WITH_SEAT
})

function canBuyAncillary(source, clientId, contentSource) {
  const validSource = sourcesCanBuyAncillary.value.includes(source)
  const validClientId = ['VN1A'].includes(source) ? !['INTERNAL'].includes(clientId) : true
  const validContentSource = ['1A'].includes(source) ? ['GDS'].includes(contentSource) : true
  return validSource && validClientId && validContentSource
}

function canBuySeat(source, clientId, contentSource) {
  const validSource = sourcesCanBuySeat.value.includes(source)
  const validClientId = ['VN1A'].includes(source) ? !['INTERNAL'].includes(clientId) : true
  const validContentSource = true
  return validSource && validClientId && validContentSource
}

function bundleBySsrCode(code) {
  return store.getters['globalConfig/getJQBundlesByCode'](code)
}

const convertFirstName = firstName => {
  const arrName = firstName.split(' ')
  return arrName.map((item, index) => (index !== arrName.length - 1 ? item[0] : item)).join(' ')
}

const calculateTotalLength = (human, isConvertName = false, sources) => {
  const firstNameLength = (human.paxType === 'INFANT' && isConvertName) ? (convertFirstName(human.firstName)?.length || 0) : (human.firstName?.length || 0)
  return (human.title?.length || 0)
        + firstNameLength
        + (human.lastName?.length || 0)
        + (sources.some(s => ['1A'].includes(s)) && !['INFANT'].includes(human.paxType) ? 0 : (human.birthday?.length || 0))
}
const createData = (type, pax, totalLength, isOverLimit, canModify, infantPaxId = null) => ({
  type,
  pax: cloneDeep(pax),
  strNameInfant: type === 'double' ? convertFirstName(pax[0].firstName) : null,
  isOverLimit,
  canModify,
  totalLength,
  infantPaxId,
})
const pooledPaxCheckMaxLength = (paxs, sources) => {
  const result = []
  paxs.forEach(pax => {
    if (pax.paxType === 'INFANT' && pax.parentPaxId) {
      const adult = paxs.find(f => f.paxId === pax.parentPaxId)
      const infantArr = [pax, adult]
      const totalLength = infantArr.reduce((total, human) => total + calculateTotalLength(human, false, sources), 0)
      const totalLengthModifyINF = infantArr.reduce((total, human) => total + calculateTotalLength(human, true, sources), 0)
      const isOverLimit = sources.some(s => ['1A'].includes(s)) ? (totalLength > 57) : (totalLength > 47)
      const canModify = sources.some(s => ['1A'].includes(s))
        ? false // (isOverLimit && totalLengthModifyINF < 57) -> 1A no-edit name INF
        : (isOverLimit && totalLengthModifyINF < 47)
      const data = createData('double', infantArr, totalLength, isOverLimit, canModify, pax.paxId)
      result.push(data)
    } else {
      const totalLength = calculateTotalLength(pax, false, sources)
      const isOverLimit = sources.some(s => ['1A'].includes(s)) ? (totalLength > 57) : (totalLength > 54)
      const data = createData('one', pax, totalLength, isOverLimit, false, null)
      result.push(data)
    }
  })
  return result
}

const updatePassengerCountToLocalStorage = paxLists => {
  const storageData = JSON.parse(localStorage.getItem('searchFlight')) || {};
  ['ADULT', 'CHILD', 'INFANT'].forEach(paxType => {
    storageData[paxType.toLowerCase()] = paxLists.filter(p => p.paxType === paxType).length
  })
  localStorage.setItem('searchFlight', JSON.stringify(storageData))
}

// ANCHOR create paxList add-on by data search
const createItineraries = (flightData, isCombination) => {
  const itineraries = []
  const pushTrip = flightData.find(trip => ['VN1A'].includes(trip.source))

  if (pushTrip) {
    // has VN1A trip(s)
    const pushSegment = flightData.filter(trip => !['VN1A'].includes(trip.source)) // remaining trip
    const grBySource = groupBy(flightData, 'source')

    if (!isEmpty(pushSegment)) {
      if (grBySource.VN1A) {
        groupBy(flightData, 'source').VN1A.forEach(trip => {
          itineraries.push({
            airline: 'VN',
            source: 'VN1A',
            departure: trip.departure.IATACode,
            arrival: trip.arrival.IATACode,
            departureDate: convertISODateTime(trip.departure.at, trip.departure.timezone).ISOdatetime,
            arrivalDate: convertISODateTime(trip.arrival.at, trip.arrival.timezone).ISOdatetime,
            flightNumber: trip.flightNumber,
            operating: '',
            fareBasisCode: trip.fareOptions.fareBasisCode,
            bookingClass: trip.bookingClass,
            groupClass: trip.groupClass,
            fareValue: trip.fareOptions.fareValue,
            itineraryId: trip?.airlineItineraryId || '',
          })
        })
      }

      pushSegment.forEach(remTrip => {
        remTrip.segments.forEach(segment => {
          itineraries.push({
            airline: segment.airline,
            source: remTrip.source,
            departure: segment.departure.IATACode,
            arrival: segment.arrival.IATACode,
            departureDate: convertISODateTime(segment.departure.at, segment.departure.timezone).ISOdatetime,
            arrivalDate: convertISODateTime(segment.arrival.at, segment.arrival.timezone).ISOdatetime,
            flightNumber: segment.flightNumber,
            flightNOP: segment.flightNumber,
            fareBasisCode: remTrip.fareOptions.fareBasisCode,
            bookingClass: remTrip.fareOptions.bookingClass,
            groupClass: remTrip.fareOptions.groupClass,
            segmentId: ['QH'].includes(remTrip.source) ? segment.airlineSegmentId : segment.segmentId,
            itineraryId: ['VJ', '1A'].includes(remTrip.source) ? remTrip?.airlineItineraryId : segment.segmentValue,
            fareValue: remTrip.fareOptions.fareValue,
          })
        })
      })
    } else {
      // eslint-disable-next-line no-lonely-if
      if (grBySource.VN1A) {
        groupBy(flightData, 'source').VN1A.forEach((trip, tripIndex) => {
          itineraries.push({ // TH: VN1A GHK (combine)
            airline: 'VN',
            source: 'VN1A',
            departure: trip.departure.IATACode,
            arrival: trip.arrival.IATACode,
            departureDate: convertISODateTime(trip.departure.at, trip.departure.timezone).ISOdatetime,
            arrivalDate: convertISODateTime(trip.arrival.at, trip.arrival.timezone).ISOdatetime,
            flightNumber: trip?.flightNumber || trip?.segments?.map(s => s.flightNumber)?.join(' | ') || '',
            operating: '',
            fareBasisCode: trip.fareOptions?.fareBasisCode || trip?.fareBasisCode || '',
            bookingClass: trip.bookingClass,
            groupClass: trip.groupClass,
            fareValue: trip.fareOptions?.fareValue,
            itineraryId: trip?.airlineItineraryId || String(tripIndex + 1) || '',
          })
        })
      }
    }
  } else {
    // No VN1A trip
    // eslint-disable-next-line no-unused-vars
    flightData.map((trip, tripIndex) => trip.segments.map((segment, segmentIndex) => itineraries.push({
      airline: segment.airline,
      source: trip.source,
      departure: segment.departure.IATACode,
      arrival: segment.arrival.IATACode,
      departureDate: convertISODateTime(segment.departure.at, segment.departure.timezone).ISOdatetime,
      arrivalDate: convertISODateTime(segment.arrival.at, segment.arrival.timezone).ISOdatetime,
      flightNumber: segment.flightNumber,
      flightNOP: segment.flightNumber?.trim() || '',
      fareBasisCode: trip.fareOptions?.fareBasisCode || '',
      bookingClass: trip.fareOptions.bookingClass || '',
      groupClass: ['TR', 'JQ'].includes(trip.source) ? trip.fareOptions?.groupClass?.split(' | ')?.[0] : (trip.fareOptions.groupClass || ''),
      segmentId: ['QH'].includes(trip.source) ? segment.airlineSegmentId : segment.segmentId,
      fareValue: trip.fareOptions?.fareValue || null,
      itineraryId: isCombination
        ? String(tripIndex + 1)
        : ['VJ', '1A'].includes(trip.source)
          ? trip?.airlineItineraryId
          : (
            ['TH', 'TR', 'JQ'].includes(trip.source)
              ? String(trip.itineraryId)
              : segment.segmentValue
          ),
    })))
  }

  return itineraries
}
const createPaxList = (search, includeInfant) => {
  const { adult, child, infant } = search
  const paxList = []
  const paxTypes = {
    ADULT: adult,
    CHILD: child,
    ...(includeInfant && { INFANT: infant }),
  }
  Object.entries(paxTypes).forEach(([type, count]) => {
    if (count) {
      paxList.push({
        type,
        count,
      })
    }
  })
  return paxList
}
// ANCHOR fetch list ancillary
const fetchListAncillary = async (flightData, dataSearch, bookingId = undefined, isCombination = false) => {
  const payload = {
    source: flightData[0].source,
    paxList: createPaxList(dataSearch, true),
    itineraries: createItineraries(flightData, isCombination),
    bookingId: ['QH'].includes(flightData[0].source) ? flightData[0].fareOptions?.fareValue : bookingId,
  }

  try {
    const res = await apiBooking.fetchListAncillary(payload)
    const modifyRes = {
      ssrBags: res.ssrBags.map(i => ({
        ...i,
        source: flightData[0].source,
      })),
      ssrOthers: res.ssrOthers.map(i => ({
        ...i,
        source: flightData[0].source,
      })),
    }
    return modifyRes
  } catch (err) {
    console.error('Error fetching ancillary:', err)
    throw err
  }
}
async function fetchSeatMap(flightData, dataSearch, bookingId = undefined) {
  try {
    const payload = {
      source: flightData[0].source,
      paxList: createPaxList(dataSearch, false),
      itineraries: createItineraries(flightData),
      bookingId: ['QH'].includes(flightData[0].source) ? flightData[0].fareOptions?.fareValue : bookingId,
    }

    const res = await apiBooking.fetchSeatMap(payload)
    return res
  } catch (err) {
    console.error('Error fetching seat map:', err)
    throw err
  }
}

const getAirlineNameByCode = code => store.getters['globalConfig/getAirlineNameByCode'](code)

// để computed ở ngoài khi unRegisterStore thì sẽ lỗi khi gọi các computed

// =================== *** EXPORT DEFAULT *** ===================
export default function useCreateBookingHandle() {
  function delay(ms) {
    return new Promise(resolve => setTimeout(resolve, ms))
  }

  const getSsrOthers = computed(() => store.getters['app-create-booking/getSsrOthers']) // res list-ancillary.ssrOthers
  const isHideFunction = computed(() => store.getters['app-create-booking/getIsHideFunction'])

  const loadingAncillary = computed(() => store.getters['app-create-booking/getIsRetryLoadingAncillary'])
  const loadingSeatMap = computed(() => store.getters['app-create-booking/getIsRetryLoadingSeatMap'])

  const getSsrBags = computed(() => store.getters['app-create-booking/getSsrBags']) // res list-ancillary.ssrBags
  const getAddonsData = computed(() => store.getters['app-create-booking/getAddonsData']) // list ancillary selected
  const getSeatMapData = computed(() => store.getters['app-create-booking/getSeatMapData']) // res seat-map
  const getPaxSeatLists = computed(() => store.getters['app-create-booking/getPaxSeatLists']) // list all pax với ghế v2
  const getEnableRetryAddons = computed(() => store.getters['app-create-booking/getEnableRetryAddons']) // check loading [list-ancillary, seat-map, draft-booking]
  const totalSeatPrice = computed(() => getPaxSeatLists.value.reduce((a, seat) => a + seat?.seatPrice || 0, 0))

  function getPaxSeatItem(paxId, itineraryId, airlineSegmentId, source) {
    return getPaxSeatLists.value.find(seatItem => seatItem?.paxId === paxId
      && seatItem?.itineraryId === itineraryId
      && seatItem?.airlineSegmentId === airlineSegmentId
      && seatItem?.source === source)
  }

  return {
    sourcesCanBuyAncillary,
    sourcesCanBuySeat,
    sourcesRequireVerifyPrice,
    isHideFunction,
    CREATE_BOOKING_STORE_MODULE_NAME,
    VJ_CHINA_REQUIRED_PASSPORT_IATA_CODES,
    getAddonsData,
    loadingAncillary,
    loadingSeatMap,
    getSsrBags,
    getSsrOthers,
    getSeatMapData,
    getEnableRetryAddons,
    getPaxSeatLists, // v2
    totalSeatPrice, // v2

    delay,
    convertFirstName,
    pooledPaxCheckMaxLength,
    updatePassengerCountToLocalStorage,
    canBuySeat,
    getPaxSeatItem,
    canBuyAncillary,
    fetchSeatMap,
    fetchListAncillary,
    bundleBySsrCode,
    getAirlineNameByCode,

    // start-> del when rfc
    isChangeBundle,
    toggleChangeBundle,
    // end-> del when rfc

  }
}
